export default __webpack_public_path__ + "aad62f694f47e4b4eebf33394949f4ed.png";